<template>
  <!-- 用户管理 -->
  <div class="page-container" id="userManagementContainer">
    <el-form
      :model="userManagementForm"
      ref="ruleFormRef"
      class="form-panel"
      label-position="top"
      :validateOnRuleChange="false"
    >
      <el-col :span="24">
        <el-row class="content-panel user-mange-query-panel" id="searchPanel">
          <el-col>
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item :label="$t('table.loginAccount')">
                  <el-input
                      size="mini"
                      v-model="userManagementForm.userName" case="upper"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('table.chineseName')">
                  <el-input
                      size="mini"
                      v-model="userManagementForm.userNameCn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('table.englishName')">
                  <el-input
                      size="mini"
                      v-model="userManagementForm.userNameEn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('table.eMailAddress')">
                  <el-input
                      size="mini"
                      v-model="userManagementForm.email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item :label="$t('table.telephoneNumber')">
                  <el-input
                      size="mini"
                      v-model="userManagementForm.mobilePhone"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('table.dataPermission')">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_sysDataAuthority"
                    :query-method="associate_queryMethod_sysDataAuthority"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="dataAuthorityName"
                    value-prop="dataAuthorityName"
                    placeholder=""
                    v-model="userManagementForm.dataAuthorityName"
                    size="mini"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('table.effective')">
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="userManagementForm.isActive"
                    placeholder="请选择" clearable
                  >
                    <el-option
                      v-for="item in dict.MD_CODE_YESNO"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <el-button type="primary" size="small" plain @click="handleQuery"
              >{{$t('button.query')}}</el-button
            >
            <el-button type="primary" size="small" plain @click="handleReset"
              >{{$t('button.reset')}}</el-button
            >
            <el-button type="primary" size="small" plain @click="handleAdd"
              >{{$t('button.addUser')}}</el-button
            >
            <el-button type="danger" size="small" plain @click="handleDelete"
              >{{$t('button.deleteUser')}}</el-button
            >
            <el-button type="primary" size="small" plain @click="handleEnable"
              >{{$t('button.takeEffect')}}</el-button
            >
            <el-button type="danger" size="small" plain @click="handleDisable"
              >{{$t('button.loseEfficacy')}}</el-button
            >
          </el-col>
        </el-row>
        <!-- 表格-start -->
        <el-row style="margin-top: 15px" >
          <hot-table
            ref="userManagementTableRef"
            :data-source="userManagementTableDataSource"
            :settings="userManagementTableSettings"
            col-settings-key="userManagement"
             @cellDblclick="toUserEdit"
          >
            <hot-column
              :has-tip="true"
              data="userName"
              :title="$t('table.loginAccount')"
              width="150"
            >
            </hot-column>

            <hot-column
              :has-tip="true"
              data="userNameCn"
              :title="$t('table.chineseName')"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="roleList"
              :title="$t('table.roleName')"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="regionList"
              :title="$t('table.OwningRegion')"
              width="150"
            ></hot-column>
            <!-- <hot-column :has-tip="true" data="age" title="年龄" width="150">
            </hot-column> -->
            <hot-column
              :has-tip="true"
              data="defaultOfficeName"
              :title="$t('table.affiliatedCompany')"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="dataAuthorityName"
              :title="$t('table.dataPermission')"
              width="150"
            >
            </hot-column>
            <hot-column
                :has-tip="true"
                data="isActive"
               :title="$t('table.valid')"
                width="150"
                dictName="MD_CODE_YESORNO"
            >
            </hot-column>
            <hot-column :has-tip="true" data="activeStartTime" :title="$t('table.effectiveTime')" width="150"
                        date-format="YYYY-MM-DD HH:mm:ss">
            </hot-column>
            <hot-column :has-tip="true" data="activeEndTime" :title="$t('table.failureTime')" width="150"
                        date-format="YYYY-MM-DD HH:mm:ss">
            </hot-column>

            <hot-column
              :has-tip="true"
              data="userNameEn"
              :title="$t('table.englishName')"
              width="150"
            >
            </hot-column>
            <hot-column :has-tip="true" data="sex" :title="$t('table.sex')" width="150"
                        dictName="sex">
            </hot-column>
            <hot-column :has-tip="true" data="mobilePhone" :title="$t('table.mobilePhone')" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="tel" :title="$t('table.officeTelephone')" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="fax" :title="$t('table.fax')" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="email" :title="$t('table.eMailAddress')" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="qq" :title="$t('table.qqNumber')" width="150">
            </hot-column>
            <hot-column :has-tip="true" data="identityCardNo" :title="$t('table.identityCardNo')" width="150">
            </hot-column>
          </hot-table>
        </el-row>
      </el-col>
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination
          :current-page="pageConfig.currentPage"
          :layout="pageConfig.layout"
          :page-size="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :total="pageConfig.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <!-- 分页end -->
    </el-form>
  </div>
</template>

<script>
import { queryDictRows,queryDictionaryByCodeType } from "@/api/commonService";
import { sysDataAuthority, sysUserQuery, activeSysUser,deletesSysUser } from "@/api/system";

export default {
  name: "UserManagement",
  data() {
    return {
      associate_columns_sysDataAuthority: [
        {
          title: this.$t('associate.permissionName'),
          field: "dataAuthorityName",
        },
      ],
      dict: {
        MD_CODE_YESNO: [],
      },
      userManagementForm: {
        userName: "",
        userNameCn: "",
        userNameEn: "",
        email: "",
        mobilePhone: "",
        dataAuthorityName: "",
        isActive: "1",
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // 表格校验
      userManagementRules: {},
      // 表格数据
      userManagementTableDataSource: [],
      // 表格设置
      userManagementTableSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      isValidList: [
        {
          key: "1",
          value: "是",
        },
        {
          key: "0",
          value: "否",
        },
      ],
    };
  },
  async created() {
    await this.$permissions.loadPermissions(this.$route.path);
  },
  mounted() {
    let self = this;
    self.queryDictRows();
    this.userManagementTableSettings.height = document.body.clientHeight - document.getElementById("searchPanel").offsetHeight -150;
  },
  methods: {
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      let self = this;
      console.log(`当前页: ${val}`);
      self.pageConfig.currentPage = val;
      self.handleQuery();
    },
    associate_queryMethod_sysDataAuthority({ keyword, pageSize, currentPage }) {
      let self = this;
      let searchColumns = new URLSearchParams();
      searchColumns.append(
          "searchColumns",
          '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append(
          "searchColumns",
          '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append(
          "searchColumns",
          '{"propertyName":"isExternal","columnName": "IS_EXTERNAL","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append(
          "sortColumns",
          '{"propertyName":"dataAuthorityName","columnName":"DATA_AUTHORITY_NAME","sortDirection":"asc","sortOrder":"1"}'
      );
      searchColumns.append(
          "dataAuthorityName",
          keyword
      );
      searchColumns.append(
          "sum",
          false
      );
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
      searchColumns.append("queryResultType", "page");
      keyword
          ? searchColumns.append(
              "searchColumns",
              JSON.stringify({
                "propertyName": "dataAuthorityName",
                "columnName": "DATA_AUTHORITY_NAME",
                "dataType": "S",
                "value": keyword,
                "operation": "LIKEIC"
              })
          )
          : void 0;
      //   var searchColumns = [
      //     {
      //       propertyName: "isActive",
      //       columnName: "IS_ACTIVE",
      //       dataType: "S",
      //       value: "1",
      //       operation: "EQ"
      //     },
      //     {
      //       propertyName: "isDeleted",
      //       columnName: "IS_DELETED",
      //       dataType: "S",
      //       value: "0",
      //       operation: "EQ",
      //     },
      //   ];
      return new Promise((resolve) => {
        sysDataAuthority(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysDataAuthoritys,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //queryDictRows数据字典
    queryDictRows() {
     let self = this;
     let params={
      codeType: "MD_CODE_YESNO",
		  valueType: 'ZH',
        }
		 if(this.$cookies.get('language')==='en'){
		  params={
      codeType: "MD_CODE_YESNO",
		  valueType: 'EN',
        }
		 }
     queryDictionaryByCodeType(params).then((res) => {
        self.dict.MD_CODE_YESNO =res.records.MD_CODE_YESNO;
        let dict = [];
        self.dict.MD_CODE_YESNO.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        });
        self.$hotTableUtils.registDict({ MD_CODE_YESORNO: dict });
      });
      queryDictRows("Sex").then((res) => {
        let dict = [];
        res.Sex.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        });
        self.$hotTableUtils.registDict({ sex: dict });
      });
    },
    // 新增
    usermaintain() {
      this.$router.push({
        path: "/system/usermaintain",
      });
    },
    // 重置密码
    handleResetPwd() {
      let self = this;
      let paramslength = 0;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        return self.$coreMethods.message(
            "warning",
            this.$t('message.selectOneRecordToDelete')
        )
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 0
        })
        if (anser === true) {
        } else {
          self.$coreMethods.message("warning", "不能删除生效用户！");
        }
      }
    },
    // 启用
    handleEnable() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", this.$t('message.selectOneRecordToTakeEffect'));
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 0
        })
        if (anser === true) {
          let data = {
            active: 1,
            sysUserIds: "",
          };
          params.forEach((item) => {
            console.log(item)
            data.sysUserIds += item.sysUserId + ",";
          });
          activeSysUser(data).then((res) => {
            this.handleQuery()
          })
          self.$coreMethods.message("warning", this.$t('message.HaveComeIntoEffect'))
        } else {
          self.$coreMethods.message("warning", this.$t('message.selectAnInactiveRecord'))
        }
      }
    },
    handleAdd() {
      this.$router.push({
        name: 'UserAdd',
        params: {
          type: 'save'
        }
      })
    },
    handleDelete() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", this.$t('message.selectOneRecordToDelete'));
        return
      }
      let isAllActive = params.find(function (a) {
        return a.isActive === 1
      })
      if (!isAllActive) {
        self.$coreMethods.confirm(
            function () {
              let data = {
                ids: "",
              };
              params.forEach((item) => {
                data.ids += item.sysUserId + ",";
              });
              deletesSysUser(data).then(res => {
                if (res.success) {
                  self.handleQuery()
                  self.$coreMethods.message("success", this.$t('message.deleteSuccessful'))
                }
              })
            },
            function () {
            },
            false,
            "是否确认删除？"
        );
      } else {
        self.$coreMethods.message("warning", this.$t('message.cannotBeDeleted'))
      }
    },
    // 禁用
    handleDisable() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", this.$t('message.selectOneRecordToLoseEfficacy'))
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 1
        })
        if (anser === true) {
          let data = {
            active: 0,
            sysUserIds: "",
          };
          params.forEach((item) => {
            data.sysUserIds += item.sysUserId + ",";
          });
          activeSysUser(data).then((res) => {
            this.handleQuery()
          })
          self.$coreMethods.message("warning", this.$t('message.Expired'))
        } else {
          self.$coreMethods.message("warning", this.$t('message.selectAnInUnexpiredRecord'))
        }
      }
    },
    // 查询
    handleQuery() {
      let self = this;
      let searchColumns = new URLSearchParams();

      searchColumns.append(
          "searchColumns",
          '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append(
          "searchColumns",
          '{"propertyName":"isExternal","columnName": "IS_EXTERNAL","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append("queryResultType", "list");
      searchColumns.append("sum", false);
      searchColumns.append("currentPage", self.pageConfig.currentPage);
      searchColumns.append("pageSize", self.pageConfig.pageSize);
      for (let key in self.userManagementForm) {
        if (key === 'isActive') {
        if(self.userManagementForm.isActive){
            searchColumns.append(
                "searchColumns",
                '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": ' +
                self.userManagementForm.isActive +
                ',"operation": "EQ"}'
            );
          }
        } else {
          if (self.userManagementForm[key]) {
            searchColumns.append(
                "searchColumns",
                '{"propertyName":" ' + key + ' ","columnName": "' + key.replace(/[A-Z]/g, function ($1) {
                  return '_' + $1.toLowerCase()
                }).toUpperCase() + '","dataType": "S","value": "' +
                self.userManagementForm[key] +
                '","operation": "LIKEIC"}'
            );
          }
        }
      }


      if(JSON.parse(localStorage.getItem('userInfo')).custId!=undefined){
        searchColumns.append(
          "searchColumns",
          JSON.stringify({"propertyName":"custId","columnName": "CUST_ID","dataType": "S","value": JSON.parse(localStorage.getItem('userInfo')).custId,"operation": "EQ"})
        );
      }
      sysUserQuery(searchColumns).then((res) => {
        if (res.success) {
          self.userManagementTableDataSource = res.sysUsers;
          self.pageConfig.total = res.total;
        }
      });
    },
    // 重置
    handleReset() {
      this.userManagementForm = {
        userName: "",
        userNameCn: "",
        userNameEn: "",
        email: "",
        mobilePhone: "",
        dataAuthorityName: "",
        isActive: "1",
      };
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.handleQuery();
    },
    toUserEdit(val) {
      if (val.col === 1){
        this.$router.push({
          name: 'UserEdit',
          params: {
            sysUserId: val.record.sysUserId
          }
        })
      }
    },
  },
};
</script>

<style>
 .user-mange-query-panel{
    margin: 0;
    border-radius: 10px;
}
</style>
